// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a14fdaef","453":"c70f13e2","455":"a07489a6","977":"ebe8ef79"}[chunkId] + ".chunk.js";
};